import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { SimFlawReducerType } from 'redux/reducers/internal/SimFlaws'

export const selectInternalSimFlaws = createSelector(
  [(state: ApplicationState): SimFlawReducerType => state.InternalSimFlawStore],
  (store) => store
)

/**
 * UI-facing aliases for the wire types. Components should import these
 * rather than reaching into `redux/api/internal/SimFlaws/contract`
 * directly, so that file stays the only place referencing the wire
 * contract's exact export names (see its header comment).
 */
export type {
  TSimFlawRowDto as SimFlawRow,
  TSimFlawGroupDto as SimFlawGroup,
  TSimFlawTypeCountDto as SimFlawTypeCount,
  TSimFlawCustomerAggregateDto as SimFlawCustomerAggregate,
  TSimFlawTableAggregateDto as SimFlawTableAggregate,
  TSimFlawAggregatesDto as SimFlawAggregates
} from 'redux/api/internal/SimFlaws/contract'
